module.exports = __webpack_public_path__ + "static/media/locationTemplateWithSampleData.2fb453a6.xlsx";